export const primaryColor = '#e49042'
export const secondaryColor = '#aaa'
export const baseBg = '#f7f8f9'
export const errorColor = '#e24328'
export const warningColor = '#DBA42A'
export const successColor = '#27ae60'
